document.addEventListener("DOMContentLoaded", function () {
  const labelElements = document.querySelectorAll(".for-scroll-label-text .label-box-element");
  const scrollLinksContainer = document.querySelector(".product-section-scrollbar .scroll-links");

  labelElements.forEach((labelEl, index) => {
    const labelText = labelEl.querySelector(".label")?.textContent?.trim();
    const sectionId = labelText ? `product-${labelText.toLowerCase().replace(/\s+/g, '-')}` : `section-${index}`;

    // Assign the ID to the corresponding section element if not already present
    labelEl.setAttribute("id", sectionId);

    // Create anchor link
    const link = document.createElement("a");
    link.href = `#${sectionId}`;
    link.className = "scroll-link";
    link.textContent = labelText;

    scrollLinksContainer.appendChild(link);
  });

  // Re-fetch scroll links after dynamically adding them
  const links = document.querySelectorAll(".scroll-link");

  // Intersection Observer Setup
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.3
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const sectionId = entry.target.getAttribute("id");
      if (entry.isIntersecting) {
        links.forEach(link => {
          link.classList.toggle("active", link.getAttribute("href") === `#${sectionId}`);
        });
      }
    });
  }, observerOptions);

  // Observe all labeled sections
  labelElements.forEach(el => observer.observe(el));

links.forEach(link => {
  link.addEventListener("click", function (e) {
    e.preventDefault();

    const targetId = this.getAttribute("href");
    const targetEl = document.querySelector(targetId);
    if (targetEl) {
      const offset = 80; // Offset from top in pixels
      const topPos = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;

gsap.to(window, {
  scrollTo: {
    y: topPos,
    autoKill: false
  },
  duration: 0.5,
  ease: "expo.out",
  snap: 1  // scrollToPlugin supports snapping!
});

      links.forEach(l => l.classList.remove("active"));
      this.classList.add("active");
    }
  });
});

});
